export default __webpack_public_path__ + "static/media/test-not-ok.525e0692.svg";